import { MainMenuItem, MainMenuItemsList } from 'app/navbar/MenuConfig';

export const newMenuItems = (topMenu: any) => {
    const menuTemplatesAliases: any = {
        dataset: 'dataset_template_id',
        metric: 'dashboard_element_template_id',
        segment: 'segment_template_id',
    };
    let submenuTemplates: any = {};
    const topMenuTemplatesData = topMenu?.topMenuTemplates;

    if (topMenuTemplatesData && Object.keys(topMenuTemplatesData).length) {
        Object.keys(topMenuTemplatesData).forEach((key) => {
            if (menuTemplatesAliases[key] && topMenuTemplatesData[key].length) {
                let childrenItems = topMenuTemplatesData[key].map((item: any) => {
                    const idKey = menuTemplatesAliases[key];
                    const idValue = item[idKey];

                    const createItem: any = {
                        label: item.name,
                        translate: false,
                        key: `new_${key}_${idValue}`,
                        action: ({ createNewFunc }: { createNewFunc: any }) => {
                            createNewFunc(`/data/editor/${key}/insert/template/${idValue}`);
                        },
                    };

                    switch (key) {
                        case 'dataset':
                            createItem.searchData = {
                                groupKey: 'create_new_dataset',
                                itemType: 'create_new',
                                labelSuffix: 'none',
                            };
                            break;
                        case 'metric':
                            createItem.searchData = {
                                groupKey: 'create_new_metric',
                                itemType: 'create_new',
                                labelSuffix: 'none',
                            };
                            break;
                        case 'segment':
                            createItem.searchData = {
                                groupKey: 'create_new_dimension',
                                itemType: 'create_new',
                                labelSuffix: 'none',
                            };
                            break;
                    }

                    return createItem;
                });

                if (childrenItems.length) {
                    let createNewItem: any = {
                        label: 'new.create_new',
                        key: `create_new_${key}`,
                    };
                    switch (key) {
                        case 'dataset':
                            createNewItem.action = ({ createNewFunc }: { createNewFunc: any }) => {
                                createNewFunc('/data/editor/dataset/insert');
                            };
                            createNewItem.searchData = {
                                groupKey: 'create_new_dataset',
                                itemType: 'create_new',
                                labelSuffix: 'none',
                                label: 'new.dataset',
                            };
                            break;
                        case 'metric':
                            createNewItem.href = '/editor/element/metric/new';
                            createNewItem.searchData = {
                                groupKey: 'create_new_metric',
                                itemType: 'create_new',
                                labelSuffix: 'none',
                                label: 'new.metric',
                            };
                            break;
                        case 'segment':
                            createNewItem.action = ({ createNewFunc }: { createNewFunc: any }) => {
                                createNewFunc('/data/editor/segment/{segmentId}/form', {
                                    redirectAfter: true,
                                    uid: 'grid_popup_segmentGrid',
                                });
                            };
                            createNewItem.searchData = {
                                groupKey: 'create_new_dimension',
                                itemType: 'create_new',
                                labelSuffix: 'none',
                                label: 'new.dimension',
                            };
                            break;
                    }
                    childrenItems.push(createNewItem);
                    submenuTemplates[key] = childrenItems;
                }
            }
        });
    }

    let extReportSubmenu = undefined;
    if (topMenu?.externalReportTypes?.length) {
        extReportSubmenu = topMenu.externalReportTypes.map((item: any) => {
            return {
                label: item.title,
                translate: false,
                key: `new_ext_report_${item.external_report_type_id}`,
                href: `/editor/element/extreport/new?ert=${item.external_report_type_id}`,
                searchData: {
                    groupKey: 'create_new_external_report',
                    itemType: 'create_new',
                    labelSuffix: 'none',
                    keywords: {
                        manuLabel: true,
                    },
                },
            };
        });
    }

    let bulkExtReport = undefined;
    if (topMenu?.biTools?.length) {
        bulkExtReport = {
            label: 'new.bulk_add_ext_report',
            key: 'new_bulk_add_ext_report',
            icon: { type: 'mi', value: 'external-report' },
            searchData: {
                groupKey: 'create_new',
                subGroupKey: 'create_new_bulk_external_report',
                itemType: 'create_new',
                labelSuffix: 'none',
                keywords: {
                    manuLabel: true,
                },
            },
            children: topMenu.biTools.map((item: any) => {
                return {
                    label: item.title,
                    translate: false,
                    key: `bulk_add_ext_report_${item.alias}`,
                    href: `/editor/ext-report-mass/plugin/${item.alias}`,
                    searchData: {
                        groupKey: 'create_new_bulk_external_report',
                        itemType: 'create_new',
                        labelSuffix: 'none',
                        keywords: {
                            manuLabel: true,
                        },
                    },
                };
            }),
        };
    }

    let bulkExtContent = undefined;
    if (topMenu?.extContentTools?.length) {
        bulkExtContent = {
            label: 'new.bulk_add_ext_content',
            key: 'new_bulk_add_ext_content',
            icon: { type: 'mi', value: 'external-content' },
            searchData: {
                groupKey: 'create_new',
                subGroupKey: 'create_new_bulk_external_content',
                itemType: 'create_new',
                labelSuffix: 'none',
                keywords: {
                    manuLabel: true,
                },
            },
            children: topMenu.extContentTools.map((item: any) => {
                return {
                    label: item.title,
                    translate: false,
                    key: `bulk_add_ext_report_${item.alias}`,
                    href: `/editor/ext-content-mass/plugin/${item.alias}`,
                    searchData: {
                        groupKey: 'create_new_bulk_external_content',
                        itemType: 'create_new',
                        labelSuffix: 'none',
                        keywords: {
                            manuLabel: true,
                        },
                    },
                };
            }),
        };
    }

    let newMenuItems: MainMenuItemsList = [
        {
            label: 'new.dataset',
            key: 'new_datasets',
            action: ({ createNewFunc }) => {
                createNewFunc('/data/editor/dataset/insert');
            },
            icon: { type: 'mi', value: 'datasets' },
            condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_DATASET' }],
            children: submenuTemplates['dataset'],
            searchData: {
                groupKey: 'create_new',
                subGroupKey: 'create_new_dataset',
                itemType: 'create_new',
                labelSuffix: 'none',
                keywords: {
                    entity: ['dataset'],
                },
            },
        },
        {
            divider: true,
            condition: [{ type: 'adminOrPrivilege', params: 'PRIV_CREATE_DATASET' }],
        },
        {
            label: 'new.metric',
            key: 'new_metric',
            href: '/editor/element/metric/new',
            icon: { type: 'mi', value: 'metric' },
            children: submenuTemplates['metric'],
            searchData: {
                groupKey: 'create_new',
                subGroupKey: 'create_new_metric',
                itemType: 'create_new',
                labelSuffix: 'none',
                keywords: {
                    entity: ['metric'],
                },
            },
        },
        {
            label: 'new.report',
            key: 'new_report',
            href: '/editor/element/report/new',
            icon: { type: 'mi', value: 'report' },
            searchData: {
                groupKey: 'create_new',
                itemType: 'create_new',
                labelSuffix: 'none',
                keywords: {
                    entity: ['report'],
                },
            },
        },
        {
            label: 'new.ext_report',
            key: 'new_ext_report',
            href: '/editor/element/extreport/new',
            icon: { type: 'mi', value: 'external-report' },
            children: extReportSubmenu,
            searchData: {
                groupKey: 'create_new',
                subGroupKey: 'create_new_external_report',
                itemType: 'create_new',
                labelSuffix: 'none',
                keywords: {
                    entity: ['external_report'],
                },
            },
        },
    ];
    if (bulkExtReport) {
        newMenuItems.push(bulkExtReport as MainMenuItem);
    }
    newMenuItems = [
        ...newMenuItems,
        {
            label: 'new.ext_content',
            key: 'new_ext_content',
            href: '/editor/element/ext-content/new',
            icon: { type: 'mi', value: 'external-content' },
            searchData: {
                groupKey: 'create_new',
                itemType: 'create_new',
                labelSuffix: 'none',
                keywords: {
                    manuLabel: true,
                },
            },
        },
    ];
    if (bulkExtContent) {
        newMenuItems.push(bulkExtContent as MainMenuItem);
    }
    newMenuItems = [
        ...newMenuItems,
        {
            divider: true,
        },
        {
            label: 'new.dimension',
            key: 'new_dimension',
            action: ({ createNewFunc }) => {
                createNewFunc('/data/editor/segment/{segmentId}/form', {
                    redirectAfter: true,
                    uid: 'grid_popup_segmentGrid',
                });
            },
            icon: { type: 'mi', value: 'dimension' },
            children: submenuTemplates['segment'],
            searchData: {
                groupKey: 'create_new',
                subGroupKey: 'create_new_dimension',
                itemType: 'create_new',
                labelSuffix: 'none',
                keywords: {
                    entity: ['dimension'],
                    entityAlias: ['segment'],
                },
            },
        },
        {
            divider: true,
            condition: [
                {
                    type: 'atLeastOneCondition',
                    params: [{ type: 'isAdmin' }, { type: 'havePrivilege', params: 'PRIV_CREATE_EDIT_BURSTS' }],
                },
            ],
        },
        {
            label: 'new.burst',
            key: 'new_burst',
            action: ({ createNewFunc }) => {
                createNewFunc('/data/notification/burst/insert');
            },
            icon: { type: 'mi', value: 'burst' },
            condition: [
                {
                    type: 'atLeastOneCondition',
                    params: [{ type: 'isAdmin' }, { type: 'havePrivilege', params: 'PRIV_CREATE_EDIT_BURSTS' }],
                },
            ],
            searchData: {
                groupKey: 'create_new',
                itemType: 'create_new',
                labelSuffix: 'none',
                keywords: {
                    entity: ['burst'],
                },
            },
        },
    ];

    return newMenuItems;
};

export const newMenuItemsRegular: MainMenuItemsList = [
    {
        label: 'new.burst',
        key: 'new_burst',
        action: ({ createNewFunc }) => {
            createNewFunc('/data/notification/burst/insert');
        },
        icon: { type: 'mi', value: 'burst' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_EDIT_BURSTS' }],
    },
    {
        label: 'new.folder',
        key: 'new_folder',
        action: ({ createNewFunc }) => {
            createNewFunc('/data/notification/folder/insert');
        },
        icon: { type: 'mi', value: 'folders' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_ADD_FOLDERS' }],
    },
    {
        label: 'new.ftp',
        key: 'new_ftp',
        action: ({ createNewFunc }) => {
            createNewFunc('/data/editor/ftp/{ftpId}/form', { redirectAfter: true, uid: 'form_ftp' });
        },
        icon: { type: 'mi', value: 'ftp-connection' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_FTP_CONNECTION' }],
    },
];
